export const enum Anchors {
  CanvasFormHeader = 'CanvasFormHeader',
}
